export enum LocationType {
  TargetPlus = 'TARGET_PLUS',
  Merchandise = 'MERCHANDISE',
  Salvage = 'SALVAGE',
  Deconsolidator = 'DECONSOLIDATOR',
  HangerRefurbisher = 'HANGER_REFURBISHER',
  CRC = 'CRC',
  CarSeatProgram = 'CAR_SEAT_PROGRAM',
  HQIR = 'HQIR',
  TFC = 'TFC',
}

export enum BusinessUnit {
  RCtoRTV = 'RC_TO_RTV',
  RCtoTargetPlus = 'RC_TO_TARGET_PLUS',
  RCtoHQIR = 'RC_TO_HQIR',
  StoreSalvage = 'STORE_SALVAGE',
  RDCSalvage = 'RDC_SALVAGE',
  TFCSalvage = 'TFC_SALVAGE',
  Hangers = 'HANGERS',
  MetalRecycling = 'METAL_RECYCLING',
  RDCtoRC = 'RDC_TO_RC',
  RCtoContractedB2B = 'RC_TO_CONTRACTED_B2B',
  RCtoREBELSTORK = 'RC_TO_REBELSTORK',
  RCtoCircularRecycling = 'RC_TO_CIRCULAR_RECYCLING',
  RCtoUMB = 'RC_TO_UMB',
  DeconSalvage = 'DECON_SALVAGE',
  FCSalvage = 'FC_SALVAGE',
  CarSeats = 'CAR_SEATS',
  Beauty = 'BEAUTY',
}
